exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-block-children .block.docx-heading5-block {\n  margin-top: 18px;\n  margin-bottom: 8px;\n  font-size: 16px;\n}\n", ""]);

// exports
